import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useDeleteCalendarEventMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<unknown, Error, string>({
    mutationFn: (id: string) => api.delete(`calendar-events/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['calendar-events'] });
    },
  });

  const deleteCalendarEvent = async (id: string) => {
    return mutateAsync(id);
  };

  return {
    deleteCalendarEvent,
    isLoading,
    error,
  };
};
